module.exports = __webpack_public_path__ + "static/media/background-mask-mobile-mirror.f1b34ee2.svg";